import { Box, TextField } from '@mui/material';
import React from 'react';
import Label from '../UI/Label/Label';
import { useAuthStore } from '../../store/storeAuth';
import TagInput from '../Test/TagInput';

interface RawFilesFormProps {
  formData: any;
  onChange: (e: any) => void;
  nodeId: string;
  findColor: any;
  isActiveEdge: any;
  edges: any;
  data: any;
}

export function RawFilesForm({
  formData,
  onChange,
  nodeId,
  findColor,
  isActiveEdge,
  edges,
  data,
}: RawFilesFormProps) {
  const { user } = useAuthStore(state => state);

  return (
    <Box width={'370px'}>
      <Box
        sx={{
          margin: '10px 0',
        }}
      >
        <TagInput
          key={nodeId}
          placeholder={'Enter file name'}
          onChange={onChange}
          value={formData.fileName}
          dataConnected={data?.fileNameData || []}
          isAdvanced={true}
          labelName="New File Name"
          findColor={findColor}
          isCollapsed={false}
          handleId={'fileName'}
          nodeId={nodeId}
          isActive={isActiveEdge(edges, nodeId, 'fileName', 'target')}
          advancedCollapsed={true}
          name="fileName"
          fullWidth
          InputProps={{
            style: {
              color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
            },
          }}
          labelStyle={{
            marginTop: '16px',
          }}
          sx={{
            color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
            bgcolor: user?.theme === 'dark' ? '#1D2939' : '#F9FAFB',
            border: `2px solid ${
              user?.theme === 'dark' ? '#475467' : '#EAECF0'
            }`,
          }}
          handleSettings={{ top: '50.5px' }}
        />
      </Box>
    </Box>
  );
}
